import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import FiltersResponse from "~/cabinet/ts/data/system/api/FiltersResponse";
import {AbstractEntityBuilder} from "~/ts/library/AbstractEntity";
import AbstractApiRequest from "~/core-ui/ts/request/AbstractApiRequest";
import {AbstractApiResult} from "~/core-ui/ts/request/AbstractApiResult";

export default class ReactiveFilterableRequest<DataClass extends object, ParamsClass extends object = {}> extends ReactiveRequest<DataClass> {
    private _filtersRequest?: ReactiveRequest<FiltersResponse<ParamsClass>>;

    constructor(dataRequest: AbstractApiRequest<AbstractApiResult<DataClass, any>, DataClass>, filtersRequest?: AbstractApiRequest<any, ParamsClass>) {
        super(dataRequest, false);
        if (filtersRequest) {
            let filtersResultType: any = FiltersResponse;
            let paramsType = filtersRequest.dataType;
            if (paramsType != null) {
                filtersResultType = class extends FiltersResponse<ParamsClass> {
                    protected get paramsClass(): AbstractEntityBuilder<ParamsClass> {
                        return paramsType;
                    }
                }
                filtersRequest.dataType = filtersResultType;
            }
            this._filtersRequest = (new ReactiveRequest(filtersRequest as any, true));
        }
    }

    public get filters() {
        return this.filtersRequest?.data?.filters;
    }

    public get params(): ParamsClass | undefined {
        return this.filtersRequest?.data?.params;
    }

    public get disabled() {
        return this.filtersRequest && !this.filtersRequest.data;
    }

    public get filtersRequest() {
        return this._filtersRequest;
    }

    get isLoading(): boolean {
        return this.loading || !!this.filtersRequest?.isLoading;
    }

}